<template>
  <div class="body">
    <div :class="`area area${fid}`" >
      <!-- <strong>{{ areaList[fid] }}</strong> -->
      <!-- <div  style="padding-top: 23vw;" v-if="fid == 4">
        <div>
          <p style="" v-if="amount">第一轮补贴预兑付进度{{ amount.percent >= 25.9 ? 100 : (amount.percent/0.259).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 25.9 ? 100 : (amount.percent/0.259).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第二轮补贴预兑付进度{{amount.percent >= 50.79 ? 100 : ((amount.percent-25.9)/0.2489).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 50.79 ? 100 : ((amount.percent-25.9)/0.2489).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第三轮补贴预兑付进度{{amount.percent >= 50.79 ? (amount.percent >= 100 ? 100 : ((amount.percent-50.79)/0.492).toFixed(2) )  : 0 }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 50.79 ? (amount.percent >= 100 ? 100 : ((amount.percent-50.79)/0.492).toFixed(2) ) : 0" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p>补贴额度已用完，目前处于候补审核状态，越城区将于11月12日17点关闭。</p>
        </div>
      </div>
      <div  style="padding-top: 23vw;" v-else-if="fid == 10">
        <div>
          <p style="" v-if="amount">第一轮补贴预兑付进度{{ amount.percent >= 25.9 ? 100 : (amount.percent/0.3151).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 25.9 ? 100 : (amount.percent/0.3151).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第二轮补贴预兑付进度{{amount.percent >= 52.51 ? 100 : ((amount.percent-31.51)/0.21).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 52.51 ? 100 : ((amount.percent-31.51)/0.21).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第三轮补贴预兑付进度{{amount.percent >= 52.51 ? ((amount.percent-52.51)/0.4749).toFixed(2) : 0 }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 52.51 ? ((amount.percent-52.51)/0.4749).toFixed(2) : 0" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p>补贴额度即将用完，系统将于11月12日中午12点关闭</p>
        </div>
      </div>
      <div  style="padding-top: 23vw;" v-else-if="fid == 7">
        <div>
          <p style="" v-if="amount">第一轮补贴预兑付进度{{ amount.percent >= 43.276 ? 100 : (amount.percent/0.43276).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 25.9 ? 100 : (amount.percent/0.43276).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第二轮补贴预兑付进度{{amount.percent >= 72.127 ? 100 : ((amount.percent-43.276)/0.2885).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 61.285 ? 100 : ((amount.percent-43.276)/0.2885).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第三轮补贴预兑付进度{{amount.percent >= 72.127 ? ((amount.percent-72.127)/0.27873).toFixed(2) : 0 }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 61.285 ? ((amount.percent-72.127)/0.27873).toFixed(2) : 0" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p>上虞区第三轮补贴即将结束，申报端口将于12月3日12点关闭。</p>
        </div>
        
      </div>
      <div  style="padding-top: 23vw;" v-else-if="fid == 8">
        <div>
          <p style="" v-if="amount">第一轮补贴预兑付进度{{ amount.percent >= 36.77 ? 100 : (amount.percent/0.3677).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 25.9 ? 100 : (amount.percent/0.3677).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第二轮补贴预兑付进度{{amount.percent >= 61.285 ? 100 : ((amount.percent-36.77)/0.245).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 61.285 ? 100 : ((amount.percent-36.77)/0.245).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第三轮补贴预兑付进度{{amount.percent >= 61.285 ? ((amount.percent-61.285)/0.38715).toFixed(2) : 0 }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 61.285 ? ((amount.percent-61.285)/0.38715).toFixed(2) : 0" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p>补贴额度已用完，目前处于已申报后补人员审核状态。</p>
        </div>
      </div>
      <div style="padding-top: 23vw;" v-else-if="fid == 5">
        <div>
          <p style="" v-if="amount">第一轮补贴预兑付进度{{ amount.percent >= 60 ? 100 : (amount.percent/0.6).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 60 ? 100 : (amount.percent/0.6).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第二轮补贴预兑付进度{{amount.percent > 60 ? ((amount.percent-60)/0.4).toFixed(2) : 0 }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent > 60 ? ((amount.percent-60)/0.4).toFixed(2) : 0" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p>经第二轮线下抽查后，滨海新区目前补贴资金尚有少量剩余。申报入口将于11月24日9点至26日24点短暂重开。遵循先到先得，补完即止的原则。咨询电话：0575-89296720</p>
        </div>
      </div>
      <div style="padding-top: 23vw;" v-else-if="fid > 5 && fid < 10 && fid != 8 && fid != 7">
        <div>
          <p style="" v-if="amount">第一轮补贴预兑付进度{{ amount.percent >= 60 ? 100 : (amount.percent/0.6).toFixed(2) }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent >= 60 ? 100 : (amount.percent/0.6).toFixed(2)" color="#07c160" />
        </div>
        <div style="margin-top: 5vw;">
          <p  v-if="amount">第二轮补贴预兑付进度{{amount.percent > 60 ? ((amount.percent-60)/0.4).toFixed(2) : 0 }}%</p>
          <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent > 60 ? ((amount.percent-60)/0.4).toFixed(2) : 0" color="#07c160" />
        </div>
      </div>
      <div>
        <p style="padding-top: 23vw;" v-if="amount">补贴预兑付进度{{ amount.percent }}%</p>
        <van-progress v-if="amount" class="area-progress" style="width: 60%;" :percentage="amount.percent" color="#07c160" />
      </div> -->
      <p style="padding-top: 26vw;"> 12月9日9时开放申请<br/> 申请截止日期2024年12月31日</p>
      <p style="padding-top: 0.5rem;line-height: 1.3rem;font-weight: bold;">审核通过的申请人，经公示和实地核验后，待补贴资金落实到位后下发补贴资金。<br/>适老化政策和旧房装修每人且每套仅能享受一次。</p>
    </div>
    <div class="loading" v-if="loading"><van-loading style="position: absolute;left:50%;right:50%;top: 50%;" type="spinner" /></div>
    <div v-if="!loading && auth">
      <van-tabs v-model="activeTab">
        <van-tab title="待审核" name="2">
          <ListComponent :refresh="refresh" :status="2" :active="activeTab" :ffid="fid" :car-modify="false"  @refreshed="refresh = false"/>
        </van-tab>
        <van-tab title="已通过" name="4">
          <ListComponent  :status="4" :active="activeTab" :ffid="fid" :car-modify="false"/>
        </van-tab>
        <van-tab title="已作废" name="-1">
          <ListComponent  :status="-1" :active="activeTab" :ffid="fid" :car-modify="false"/>
        </van-tab>
      </van-tabs>
      <div class="newOne" v-if="ts > 1733706000">
        <van-button class="btn" round  type="primary" @click="newForm">点击申报</van-button>
      </div>
    </div>
    
    <div v-else-if="!loading">
      <img v-if="fid == 1" style="width: 100%;" src="//img.shaoxing.com.cn/a/10001/202402/1051c650e4821671e678b04f93d2a5e6.jpeg" alt="">
      <img v-else-if="fid == 2" style="width: 100%;" src="//img.shaoxing.com.cn/a/10001/202404/f421c85539119cc9aef642360bb1ebd5.jpeg" alt="">
    </div>
  </div>
</template>
<script>
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()

import axios from 'axios'
import { util,mc } from '../../assets/common2.js'
import ListComponent from '@/components/ListComponent.vue'
// import { Loading } from 'vant'
export default {
  name: 'HouseList',
  props: {
  },
  data () {
    return {
      ts: null,
      fid: 4,
      activeTab: '1',
      refresh: false,
      auth: false,
      loading: true,
      areaList: {
        4:'越城区',
        5:'滨海新区',
        6:'柯桥区',
        7:'上虞区',
        8:'诸暨市',
        9: '嵊州市',
        10: '新昌县'
      },
      amount: null
    }
  },
  components: {
    ListComponent
  },
  computed: {
  },
  created: function () {
    if (!mc.isClient()) {
      this.$router.replace('/house/index')
    } else {
      this.fid = this.$route.params.fid ? this.$route.params.fid : 1
      this.$store.commit('setFid',this.fid)
      // console.log(vConsole);
      setTimeout(() => {
        this.getAmount()
      }, 500)
      this.ts = Math.round(new Date() / 1000)
      this.auth = true
      this.loading = false
    }
    
  },
  mounted: function () {
    
  },
  methods: {
    newForm() {
      this.refresh = false
      this.$router.push(`/house/form/${this.fid}/0`)
      
    },
    getAmount() {    
      util.Erequest((data) => {     
        axios.post(`/encrypt2/form/house/amount?userid=${data['data']['userid']}&timestamp=${data['data']['timestamp']}&sign=${data['data']['signature']}&nonce=${data['data']['nonce']}&fid=${this.fid}`).then(res => {
            if (res.data.msg == 'ok') {
              this.amount = res.data.amount
              this.amount.percent = (this.amount.percent * 100).toFixed(2)
            }
          }).catch(() => {
            this.$toast('网络繁忙\n稍后再进')
          })
      })
    }
  },
  watch: {

  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.area {
  display: block;
  position: sticky;
  top: 0;
  height: 60vw;
  max-width: 480px;
  max-height: 422px;
  font-size: 1.1rem;
  /* line-height: 2rem; */
  padding-left: 1rem;
  text-align: left;
  background-color: #fff;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/20e72c453b8dd16a95e0ea69ddb02dd6.png);
  background-size: 100%;
  background-repeat: no-repeat;
}
.area p {
  font-size: 0.9rem;
}
.area4 {
  /* height: 80vw; */
  background-color: #ffe3d0;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/1723980240776ad2a2efa3d0db61b754.png);
}
.area5 {
  /* height: 77vw; */
  background-color: #ffe3d0;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/9bb0e96394ee1bf2723ea415b7c93c8d.png);
}
.area6 {
  /* height: 58vw; */
  background-color: #ffe3d0;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/0e44971880215a3fbae4646320b91240.png);
}
.area7 {
  /* height: 84vw; */
  background-color: #ffe3d0;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/e7b9cd621d2df980a946a8fc718c8fb1.png);
}
.area9 {
  /* height: 58vw; */
  background-color: #ffe3d0;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/8027905f6dff8a7b297a643d0c5b07b9.png);
}
.area8 {
  /* height: 80vw; */
  background-color: #ffe3d0;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/4a8841b5230da1d2a4c49f8e8bdbf9e1.png);
}
.area10 {
  /* height: 77vw; */
  background-color: #ffe3d0;
  background-image: url(//res.shaoxing.com.cn/a/10001/202409/cff2ad9ade570f2fa6a01f62f1001115.png);
}
.loading {
  width: 100%;
  height: 100vh;
}
.newOne {
  position:fixed;
  bottom: 6rem;
  left: 50%;
  /* right: 2rem; */
}
.newOne .btn {
  /* width: 3.5rem; */
  width: 8rem;
  height: 3rem;
  margin: -4rem;
}
.body .van-tabs__wrap {
  position: sticky;
  top: 16px;
  z-index: 999;
}
.body .van-search {
  position: sticky;
  top: 60px;
  z-index: 999;
}
.area-progress {
  margin-top: 1rem;
}
</style>
<style>
html,body {
  height: 100%
}

</style>
